'use client'

import { useEffect, useState } from 'react'
import { useLocale } from 'use-intl'
import { useTranslations } from 'next-intl'
import { SearchableSelect } from '@/shared/ui/select'
import { InstitutionItem } from '@/shared/ui/institution-item'
import { IInstitution } from '@/interfaces/institutions'
import getInstitutions from '@/actions/getInstitutions'
import { localeMap } from '@/shared/utils/directus'
import styles from './institutions-searchable.module.scss'

type Option = {
  value: string | number
  label: string
}

interface InstitutionsSearchableProps {
  options: Option[]
  institution: IInstitution[]
}

export const InstitutionsSearchable = (props: InstitutionsSearchableProps) => {
  const { options, institution } = props
  const [loading, setLoading] = useState(false)
  const [countryId, setCountryId] = useState('')
  const [list, setList] = useState<IInstitution[]>(institution ?? [])
  const currentLocale = useLocale()
  const translate = useTranslations()
  useEffect(() => {
    setLoading(true)

    getInstitutions({ is_partner: true, locale: localeMap[currentLocale], countryId: countryId || undefined })
      .then(newItems => {
        setList(newItems)
      })
      .catch(error => {
        // TODO: По хорошему тут бы показать тостер пользователю, что что-то пошло не так
        console.error()
      })
      .finally(() => {
        setLoading(false)
      })
  }, [countryId, currentLocale])

  // TODO: нужно добавить склетов для отображения состояния загрузки

  return (
    <>
      <SearchableSelect
        className={styles.select}
        options={options}
        placeholder={translate('inputPlaceholderSearch')}
        emptyMessage={translate('emptyMessage')}
        onChange={value => {
          setCountryId(String((value as Option | null)?.value ?? ''))
        }}
      />

      <ul className={styles.list}>
        {list.map(item => (
          <InstitutionItem className={styles.item} key={item.id} {...item} />
        ))}
      </ul>
    </>
  )
}
